import filter from 'lodash/filter';
import { createReducer } from 'typesafe-actions';
import namespacedReducer from '../common/utils/new-namespaced-reducer.js';
import {
  type Actions,
  clearSelection,
  initMultiSelect,
  setFiltered,
  toggleAllSelection,
  toggleSelection
} from './actions';

export const MULTI_SELECT_NAME = 'multiSelect';

export type MultiSelectState = {
  selectAll: 'none' | 'all' | 'some';
  selected: string[];
  ids: string[];
  dataSize: number;
  filtered: string[];
};
export type MultiSelectSlice = {
  [MULTI_SELECT_NAME]: Record<string, MultiSelectState>;
};

export const initialMultiSelectState: MultiSelectState = {
  selectAll: 'none',
  selected: [],
  ids: [],
  filtered: [],
  dataSize: 0
};

export const reducer = createReducer<MultiSelectState, Actions>(initialMultiSelectState)
  .handleType(toggleSelection.toString(), (state, { payload }) => {
    const { dataSize, selected, selectAll } = state;
    const newSelected: string[] = selected.includes(payload)
      ? selected.filter((id) => id !== payload)
      : selected.concat(payload);
    let newSelectAll = selectAll;
    if (newSelected.length === 0) {
      newSelectAll = 'none';
    } else if (newSelected.length === dataSize) {
      newSelectAll = 'all';
    } else {
      newSelectAll = 'some';
    }

    return {
      ...state,
      selected: newSelected,
      selectAll: newSelectAll
    };
  })
  .handleType(toggleAllSelection.toString(), (state) => {
    let newSelected;
    let newSelectAll: 'all' | 'some' | 'none';

    if (state.selectAll === 'all') {
      newSelected = filter(state.selected, (id) => state.filtered.includes(id));
      newSelectAll = newSelected.length === 0 ? 'none' : 'some';
    } else {
      newSelected = filter(state.ids, (id) => state.selected.includes(id) || !state.filtered.includes(id));
      newSelectAll = newSelected.length === state.dataSize ? 'all' : 'some';
    }

    return {
      ...state,
      selected: newSelected,
      selectAll: newSelectAll
    };
  })
  .handleType(clearSelection.toString(), (state) => {
    return {
      ...state,
      selectAll: 'none',
      selected: []
    };
  })
  .handleType(initMultiSelect.toString(), (state, { payload }) => {
    return {
      ...initialMultiSelectState,
      dataSize: payload.length,
      ids: payload
    };
  })
  .handleType(setFiltered.toString(), (state, { payload }) => {
    return {
      ...state,
      filtered: payload
    };
  });

export const multiSelectReducer = namespacedReducer(
  (action) => action.meta?.multiSelectName,
  initialMultiSelectState,
  reducer
);
